interface Gist {
  user: {
    login: string;
  };
  id: string;
  description: string;
  updated_at: string; 
  files: {
    "thumbnail.png": {
      raw_url: string;
    };
  };
}

export default function BlockCard({ gist }: { gist: Gist }) {
  const cardStyle: React.CSSProperties = {
    fontFamily: "'Lucida Grande', Helvetica, Arial, sans-serif",
    textAlign: "left" as const,
    fill: "#3182bd",
    // steelblue
    // color: "rgb(70, 130, 180)",
    textDecoration: "none",
    boxSizing: "border-box" as const,
    float: "left" as const,
    lineHeight: "normal",
    position: "relative" as const,
    textShadow: "rgb(255, 255, 255) 1px 1px 0px,rgb(255, 255, 255) 1px -1px 0px,rgb(255, 255, 255) -1px 1px 0px, rgb(255, 255, 255) -1px -1px 0px, rgb(255, 255, 255) 1px 0px 0px, rgb(255, 255, 255) 0px 1px 0px, rgb(255, 255, 255) -1px 0px 0px, rgb(255, 255, 255) 0px -1px 0px",
    width: "232px",
    height: "82px",
    color: "rgb(0, 0, 0)",
    backgroundPosition: "50% 0%",
    borderWidth: "1px",
    borderStyle: "solid",
    margin: "0px 10px 10px 0px",
    letterSpacing: "0px",
    borderColor: "rgb(238, 238, 238) rgb(238, 238, 238) rgb(204, 204, 204)"
  };



  if (gist.files["thumbnail.png"]) {
    cardStyle.backgroundImage = `url(${gist.files["thumbnail.png"].raw_url})`;
  }

  const titleStyle = {
    textAlign: "left" as const,
    position: "absolute" as const,
    zIndex: 2,
    top: "0px",
    padding: "10px",
  };

  const dateStyle = {
    textAlign: "left" as const,
    marginLeft: "1em",
    color: "rgb(99, 99, 99)",
    display: "block",
    fontSize: "smaller",
    position: "absolute" as const,
    zIndex: 2,
    bottom: "0px",
    padding: "10px",
  };

  const showDate = false;

  return (
    <div className="block-card"  key={gist.id}>
      <a
        href={`https://bl.ockss.org/${gist.user.login}/raw/${gist.id}`}
        style={cardStyle}
        target="_blank"
        rel="noreferrer"
      >
        <span style={titleStyle}>{gist.description || "Untitled Block"}</span>
        {showDate && <span style={dateStyle}>
            {/* format the date like this: February 4, 2014 */}
            {new Date(gist.updated_at).toLocaleDateString("en-US", {
                month: "long",
                day: "numeric",
                year: "numeric",
            })}
        </span>}
      </a>
    </div>
  );
}